import { render, staticRenderFns } from "./HabilitacionesForm.vue?vue&type=template&id=7a35d61e&"
import script from "./HabilitacionesForm.vue?vue&type=script&lang=js&"
export * from "./HabilitacionesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports